<template>
  <div class="animated fadeIn">
    <b-modal id="groupForm"  title="Заполните данные потока" ok-variant="success" @ok="handleOk" cancel-title="Отмена" ok-title="Создать">
      <b-form ref="form" @submit.prevent="addGroup">
        <b-form-group>
          <label>Название потока (например, Поток № 1)</label>
          <b-form-input :class="$v.groupForm.title.$invalid ? 'is-invalid' : 'is-valid'" required v-model="groupForm.title" />
        </b-form-group>
        <b-form-group>
          <label>Дата начала обучения</label>
          <b-form-input :class="$v.groupForm.startDate.$invalid ? 'is-invalid' : 'is-valid'" required type="date" v-model="groupForm.startDate" />
        </b-form-group>
        <b-form-group>
          <label>Дата завершения обучения</label>
          <b-form-input :class="$v.groupForm.endDate.$invalid ? 'is-invalid' : 'is-valid'" required type="date" v-model="groupForm.endDate" />
        </b-form-group>
      </b-form>
    </b-modal>
    <b-modal size="xl" id="addToGroupForm"  title="Выберите поток" cancel-title="Отмена" :hide-footer="true">
      <b-table v-if="addingGroups.length" class="mb-0 table-outline" :fields="groupFields" responsive striped hover :items="addingGroups" head-variant="light">
        <div slot="start_date" slot-scope="scope">
          {{ scope.item.start_date | formatDate('DD.MM.YYYY') }}
        </div>
        <div slot="end_date" slot-scope="scope">
          {{ scope.item.end_date | formatDate('DD.MM.YYYY') }}
        </div>
        <div slot="company_count" slot-scope="scope">
          {{ scope.item.companies.length }}
        </div>
        <div slot="status" slot-scope="scope">
          {{ scope.item.status_ru }}
        </div>
        <div slot="edits" slot-scope="scope">
          <b-button size="sm" @click="addToGroup(scope.item.id)" variant="success">
            <i class="fa fa-check"></i> Выбрать
          </b-button>
        </div>
      </b-table>
    </b-modal>
    <b-modal size="xl" id="groupFormEdit" :hide-footer="editGroupForm.status !== 'init'"  :title="editGroupForm.status === 'init' ? 'Заполните данные потока' : 'Данные потока'" ok-variant="success" @ok="handleEditOk" cancel-title="Отмена" ok-title="Сохранить">
      <b-form ref="editGroupFormData" @submit.prevent="editGroupFormData">
        <b-row>
          <b-col>
            <b-form-group>
              <label>Название потока (например, Поток № 1)</label>
              <b-form-input :disabled="editGroupForm.status !== 'init'" :class="$v.editGroupForm.title.$invalid ? 'is-invalid' : 'is-valid'" required v-model="editGroupForm.title" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label>Дата начала обучения</label>
              <b-form-input :disabled="editGroupForm.status !== 'init'"  :class="$v.editGroupForm.start_date.$invalid ? 'is-invalid' : 'is-valid'" required type="date" v-model="editGroupForm.start_date" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label>Дата завершения обучения</label>
              <b-form-input :disabled="editGroupForm.status !== 'init'"  :class="$v.editGroupForm.end_date.$invalid ? 'is-invalid' : 'is-valid'" required type="date" v-model="editGroupForm.end_date" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group class="pull-right">
              <b-check :disabled="editGroupForm.status !== 'init' || (!editGroupForm.companies || editGroupForm.companies.length === 0)" v-model="sendToCrm">Сформировать поток</b-check>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-table v-if="editGroupForm.companies && editGroupForm.companies.length" class="mb-0 table-outline" :fields="editGroupForm.status === 'init' ? {
              name: {
                label: 'Название',
                class: 'text-bold text-center'
              },
              ogrn: {
                label: 'ОГРН'
              },
              edits: {
                label: 'Действия'
              }
            } : {
              name: {
                label: 'Название',
                class: 'text-bold text-center'
              },
              ogrn: {
                label: 'ОГРН'
              }}" responsive striped hover :items="editGroupForm.companies" head-variant="light">
              <div slot="edits" slot-scope="scope">
                <b-button size="sm" @click="deleteCompany(scope.item.id)" variant="danger">
                  <i class="fa fa-trash"></i>
                </b-button>
              </div>
            </b-table>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <b-modal id="userForm"  title="Заполните пользователя" ok-variant="success" @ok="handleUserOk" cancel-title="Отмена" ok-title="Отправить">
      <b-form ref="formUser" @submit.prevent="addUser">
        <b-form-group>
          <label>Фамилия</label>
          <b-form-input :class="$v.userForm.lastname.$invalid ? 'is-invalid' : 'is-valid'" required v-model="userForm.lastname" />
        </b-form-group>
        <b-form-group>
          <label>Имя</label>
          <b-form-input :class="$v.userForm.firstname.$invalid ? 'is-invalid' : 'is-valid'" required v-model="userForm.firstname" />
        </b-form-group>
        <b-form-group>
          <label>Отчество</label>
          <b-form-input :class="$v.userForm.middlename.$invalid ? 'is-invalid' : 'is-valid'" required v-model="userForm.middlename" />
        </b-form-group>
        <b-form-group>
          <label>Email</label>
          <b-form-input :class="$v.userForm.email.$invalid ? 'is-invalid' : 'is-valid'" required v-model="userForm.email" />
        </b-form-group>
        <b-form-group>
          <label>Телефон</label>
          <masked-input type="tel" class="form-control" required :class="userForm.phone ? (userForm.phone.replace(/\D/g, '').length < 11 ? 'is-invalid' : 'is-valid') : 'is-invalid'" v-model="userForm.phone" mask="\+\7 (111) 111-11-11" />
        </b-form-group>
        <b-form-group>
          <file-upload
            ref="upload"
            :class="!$refs.upload || !$refs.upload.active ? 'btn btn-sm btn-warning' : 'btn btn-sm btn-secondary'"
            :post-action="postAction"
            :headers="headers"
            :data="{context: 'default'}"
            name="binaryContent"
            @input-file="inputFile"
          >
            <i class="fa fa-upload"></i>
            {{$refs.upload && $refs.upload.active ? 'Загрузка ...' : 'Загрузить направление'}}
          </file-upload>
          {{ userForm.file ? userForm.file.name : '' }}
        </b-form-group>
      </b-form>
    </b-modal>
    <b-row v-if="programs">
      <b-col>
        <b-card>
          <template slot="header">
            <strong>Программа обучения</strong> <directory slug="potoki-obucheniya-vybor-programmy"/>
          </template>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col>
                  <label>Выберите программу</label>
                </b-col>
                <b-col md="9">
                  <b-form-select v-model="program" :options="programs" value-field="id" text-field="name"></b-form-select>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="groups">
      <b-col>
        <b-card>
          <template slot="header">
            <strong>Потоки обучения</strong> <directory slug="potoki-obucheniya-vybor-potoka" />
          </template>
          <b-card-body>
            <b-table v-if="groups.length" class="mb-0 table-outline" :fields="groupFields" responsive striped hover :items="groups" head-variant="light">
              <div slot="start_date" slot-scope="scope">
                {{ scope.item.start_date | formatDate('DD.MM.YYYY') }}
              </div>
              <div slot="end_date" slot-scope="scope">
                {{ scope.item.end_date | formatDate('DD.MM.YYYY') }}
              </div>
              <div slot="company_count" slot-scope="scope">
                {{ scope.item.companies.length }}
              </div>
              <div slot="status" slot-scope="scope">
                {{ scope.item.status_ru }}
              </div>
              <div slot="edits" slot-scope="scope">
                <b-btn-group v-if="scope.item.status === 'init'">
                  <b-button size="sm" @click="editGroup(scope.item)" variant="primary">
                    <i class="fa fa-edit"></i>
                  </b-button>
                  <b-button size="sm" @click="deleteGroup(scope.item.id)" variant="danger">
                    <i class="fa fa-trash"></i>
                  </b-button>
                </b-btn-group>
                <b-btn-group v-else>
                  <b-button size="sm" @click="editGroup(scope.item)" variant="success">
                    <i class="fa fa-eye"></i>
                  </b-button>
                </b-btn-group>
              </div>
            </b-table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <template slot="header">
            <b-button-group class="pull-right">
              <b-button @click="showGroupForm" variant="primary" size="sm" v-if="sendIds.length">
                <i class="fa fa-plus"></i>&nbsp;Создать поток
              </b-button>
              <b-button v-if="addingGroups.length && sendIds.length" @click="$bvModal.show('addToGroupForm')" variant="warning" size="sm">
                <i class="fa fa-save"></i>&nbsp;Добавить в поток
              </b-button>
            </b-button-group>
            <strong>Компании</strong>
          </template>
          <b-card-body>
            <b-table v-if="companies.length" class="mb-0 table-outline" :fields="fields" responsive striped hover :items="companies" head-variant="light">
              <div slot="check" slot-scope="scope">
                <template v-if="scope.item.user_for_crm">
                  <b-check :value="scope.item.id" v-model="sendIds">Выбрать</b-check>
                  <br/>
                  <b-button size="sm" @click="removeUser(scope.item.id)" variant="danger">
                    <i class="fa fa-minus"></i> {{ scope.item.user_for_crm.username }}
                  </b-button>
                </template>
                <template v-else>
                  <b-button size="sm" @click="showUserForm(scope.item.id)" variant="success">
                    <i class="fa fa-plus"></i> Физ. лицо
                  </b-button>
                </template>
              </div>
              <div slot="letter" slot-scope="scope">
                <span v-if="scope.item.letter" class="badge"><i class="fa fa-clock-o"></i> {{ scope.item.letter.date | formatDate }}<br/> {{ scope.item.letter.status }}</span>
              </div>
              <div slot="managers" slot-scope="scope">
                <span v-for="(manager, key) in scope.item.managers" :key="key">
                    {{manager.fullname}}<br/>
                </span>
              </div>
              <div slot="enroll" slot-scope="scope">
                <template>
                  <span :class="'badge badge-success'">Итоговый отчет</span>
                </template>
              </div>
            </b-table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import client from "../backend/client";
import * as AppStorage from "../storage/appstorage";
import { required, email, minLength } from 'vuelidate/lib/validators';
import Config from "../assets/config";
import FileUpload from 'vue-upload-component';
import MaskedInput from 'vue-masked-input';
import Directory from "../components/Directory.vue";
export default {
  name: "Group",
  data() {
    return {
      sendToCrm: false,
      groups: null,
      headers: {
        Authorization: 'Bearer ' + AppStorage.get('token')
      },
      groupForm: {},
      companies: [],
      nameState: null,
      user: JSON.parse(AppStorage.get('user')),
      fields: {
        name: {
          label: 'Название',
          class: 'text-bold text-center',
          sortable: true
        },
        ogrn: {
          label: 'ОГРН',
          sortable: true
        },
        director: {
          label: 'ФИО руководителя',
          sortable: true
        },
        post: {
          label: 'Должность руководителя',
          sortable: true
        },
        enroll: {
          label: 'Этапы комплексной диагностики',
          sortable: true
        },
        check: {
          label: 'Действия'
        }
      },
      groupFields: {
        title: {
          label: 'Название потока',
          class: 'text-bold text-center',
          sortable: true
        },
        start_date: {
          label: 'Дата начала обучения',
          sortable: true
        },
        end_date: {
          label: 'Дата конца обучения',
          sortable: true
        },
        company_count: {
          label: 'Компаний в потоке',
          sortable: true
        },
        status: {
          label: 'Статус'
        },
        edits: {
          label: 'Действия'
        }
      },
      sendIds: [],
      userForm: {},
      postAction: Config.API.url + '/api/attaches',
      currentGroup: null,
      currentCompany: null,
      editGroupForm: {},
      programs: null,
      program: 1
    }
  },
  components: {
    Directory,
    FileUpload,
    MaskedInput
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.getGroups()
      this.getCompanies()
      this.getPrograms()
    },
    getPrograms() {
      client.get('api/crm/enrollprograms').then((res) => {
        this.programs = res.data
      })
    },
    editGroup(editGroup) {
      this.editGroupForm = editGroup
      this.$bvModal.show('groupFormEdit')
    },
    deleteGroup(deleteId) {
      const result = confirm("Вы уверены, что хотите удалить поток?");
      if (result) {
        client.delete('api/crm/groups/' + deleteId).then(() => {
          this.getGroups()
          this.getCompanies()
          this.sendToCrm = false
        })
      }
    },
    sendGroup(deleteId) {
      const result = confirm("Вы уверены, что хотите отправить поток?");
      if (result) {
        client.put('api/crm/groups/' + deleteId, {inCrm: true, status: 'sended', enrollProgram: this.program}).then(() => {
          this.getGroups()
        });
      }
    },
    inputFile: function (newFile, oldFile) {

      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }

      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        if(newFile.response.media) {
          this.userForm.file = newFile.response.media;
        }
      }
    },
    showGroupForm() {
      this.$bvModal.show('groupForm')
    },
    showUserForm(company) {
      this.currentCompany = company
      this.$bvModal.show('userForm');
    },
    removeUser(company) {
      client
        .post('api/crm/groups/' + company + '/users', {
          removeMode: true,
          enrollProgram: this.program
        })
        .then((res) => {
          if(res.status === 201) {
            this.userForm = {}
            this.getGroups()
            this.getCompanies()
            this.sendToCrm = false
          }
        });
    },
    checkFormGroupValidity() {
      return this.$refs.form.checkValidity()
    },
    deleteCompany(companyId) {
      client.post('api/crm/groups/' + companyId + '/companies', {
        enrollProgram: this.program
      }).then((res) => {
        this.editGroupForm = res.data
        this.getGroups()
        this.getCompanies()
        this.sendToCrm = false
      })
    },
    checkFormUserValidity() {
      return this.$refs.formUser.checkValidity()
    },
    handleEditOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.editGroupFormData()
    },
    editGroupFormData() {
      client
        .put('api/crm/groups/' + this.editGroupForm.id, {
          startDate: this.editGroupForm.start_date,
          endDate: this.editGroupForm.end_date,
          title: this.editGroupForm.title,
          status: this.sendToCrm ? 'send' : 'init',
          enrollProgram: this.program
        })
        .then((res) => {
          if(res.status === 200) {
            this.getGroups()
            this.getCompanies()
            this.$bvModal.hide('groupFormEdit')
            this.sendToCrm = false
          }
        });
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.addGroup()
    },
    handleUserOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.addUser(bvModalEvt)
    },
    addUser() {
// Exit when the form isn't valid
      if (!this.checkFormUserValidity()) {
        return
      }
      if(!this.userForm.file || !this.userForm.file.id) {
        this.$toasted.show('Загрузите направление', {type: 'error'});
        return;
      }
      this.$nextTick(() => {
        this.userForm.enrollProgram = this.program
        client
          .post('api/crm/groups/' + this.currentCompany + '/users', this.userForm)
          .then((res) => {
            if(res.status === 201) {
              this.userForm = {}
              this.getGroups()
              this.getCompanies()
              this.sendToCrm = false
            }
          });
        this.$bvModal.hide('userForm')
      })
    },
    addToGroup(groupId) {
      this.$nextTick(() => {
        client
          .put('api/crm/groups/' + groupId, {
            companies: this.sendIds,
            enrollProgram: this.program
          })
          .then((res) => {
            if(res.status === 200) {
              this.getGroups()
              this.getCompanies()
              this.$bvModal.hide('addToGroupForm')
              this.sendIds = []
            }
          });
      })
    },
    addGroup() {
      // Exit when the form isn't valid
      if (!this.checkFormGroupValidity()) {
        return
      }
      // Hide the modal manually
      this.$nextTick(() => {
        client
          .post('api/crm/groups', {
            title: this.groupForm.title,
            startDate: this.groupForm.startDate,
            endDate: this.groupForm.endDate,
            region: this.user.region.id,
            companies: this.sendIds,
            status: 'init',
            enrollProgram: this.program
          })
          .then((res) => {
            if(res.status === 201) {
              this.getGroups()
              this.getCompanies()
              this.sendIds = []
            }
          });
        this.$bvModal.hide('groupForm')
      })
    },
    getGroups() {
      const filters = {
        'filters[region]': this.user.region.id,
        'filters[enrollProgram]': this.program
      };
      client
        .get('api/crm/groups', {
          params: filters
        })
        .then((res) => {
          this.groups = res.data
        });
    },
    getCompanies() {
      const filters = {
        'filters[region]': this.user.region.id,
        'filters[status_group]': 'candidate',
        'filters[enrollProgram]': this.program,
        'filters[acceleratorGroup]': 'null'
      };
      client
        .get('api/crm/companysparks', {
          params: filters
        })
        .then((res) => {
          this.companies = res.data.items
        });
    }
  },
  computed: {
    addingGroups() {
      return this.groups ? this.groups.filter(filter => {
        return filter.status === 'init'
      }) : []
    }
  },
  validations: {
    groupForm: {
      title: { required },
      startDate: { required },
      endDate: { required }
    },
    editGroupForm: {
      title: { required },
      start_date: { required },
      end_date: { required }
    },
    userForm: {
      firstname: { required },
      middlename: { required },
      lastname: { required },
      email: { required, email },
      phone: { required }
    },
  },
  watch: {
    program() {
      this.load()
    }
  }
}
</script>

<style scoped>

</style>
